import styles from './AmountCallout.module.scss';
import categoryRowStyles from 'src/components/atomic/organisms/budgetCategoryRow/BudgetCategoryRow.module.scss';
import Typography from 'src/components/typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import LiteralsService from 'src/services/literals/LiteralsService';
import React from 'react';
import { AmountCalloutViewModel } from 'src/types/view-models/budgets/amount-callout.view.model';
import Selectors from 'src/utils/selectors';

export default function AmountCallout({ leftText, amount, disabled, className }: AmountCalloutViewModel): JSX.Element {
    return (
        <div className={`${styles.amountCalloutContainer} ${className}`}>
            <div className={`${categoryRowStyles.subcategoryLeftIndicator} ${styles.leftIndicator}`} />
            <div
                className={`${styles.amountCalloutText} ${disabled ? styles.disabledText : ''}`}
                data-cy={Selectors.SpendSmart.AMOUNT_CALLOUT}
            >
                <Typography variant={TypographyVariants.BODY} component="p">
                    {leftText}
                </Typography>
                <div className={styles.textRight}>
                    <Typography variant={TypographyVariants.BODY_BOLD} component="p">
                        {LiteralsService.getLiteral('Budget.Create.amountLabel')}
                    </Typography>
                    <Typography variant={TypographyVariants.BODY} component="p">
                        {amount}
                    </Typography>
                </div>
            </div>
        </div>
    );
}
